import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ValidatedForm} from "../../forms/validated-form";
import {FormBuilder, Validators} from "@angular/forms";
import {AuthService} from "../../services/auth.service";
import {Router} from "@angular/router";
import {UtilService} from "../../services/util.service";
import {SessionService} from "../../services/session.service";
import {StateService} from "../../services/state.service";
import {Constants} from "../../util/constants";
import {timer} from "rxjs";
import {finalize} from "rxjs/operators";

@Component({
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent extends ValidatedForm implements OnInit, OnDestroy {

    @ViewChild('email') email: ElementRef;

    constructor(protected fb:FormBuilder,
                private authService: AuthService,
                private router: Router,
                private utilService: UtilService,
                private sessionService: SessionService,
                private state: StateService) {
        super(fb);
        this.initForm({
            email: {
                value: '',
                validators: [Validators.required, Validators.pattern(Constants.EMAIl_REGEX)],
                messages: {required: Constants.ERR_REQUIRED, pattern: Constants.ERR_INVALID_EMAIL}
            },
            password: {
                value: '',
                validators: [Validators.required],
                messages: {required: Constants.ERR_REQUIRED}
            }
        })
    }

    ngOnInit() {
        timer(100).subscribe(() => { this.email.nativeElement.focus() });
    }

    ngOnDestroy() {
        this.state.clear('targetUrl');
    }

    submit() {
        if (this.state.get('authToken'))
            this.state.clearAll();
        this.submitting = true;
        this.authService.logIn(this.fields.email.value, this.fields.password.value).pipe(
            finalize(() => {
                this.submitting=false;
                this.state.clear('targetUrl');
            })
        ).subscribe((info) => {
            this.state.setMany({
                authToken: info.token,
                maxIdle: info.idle,
                userEmail: this.fields.email.value,
                userType: info.type
            });
            this.sessionService.restartSession();
            const targetUrl:string = this.state.get('targetUrl');
            if (targetUrl)
                this.router.navigateByUrl(targetUrl).then();
            else
                this.router.navigateByUrl('/').then();
        }, this.utilService.getErrorHandler("Error logging in"));
    }

}
